import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledCommentBubble = styled('div')(({ colorChangeThreshold, isSmall }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colorChangeThreshold ? Palette.yellow.yellow300 : Palette.white,
    color: Palette.black,
    fontWeight: '600',
    fontSize: '11px',
    minWidth: isSmall ? '22px' : '24px',
    height: isSmall ? '14px' : '16px',
    borderRadius: '4px',
    outline: `2px solid ${colorChangeThreshold ? Palette.gray.gray900 : Palette.gray.gray300}`,
    position: 'relative',
    padding: isSmall ? '0 4px' : '0',
    marginLeft: isSmall ? '2px' : '14px',
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-7px',
        left: '33%',
        transform: 'translateX(-50%)',
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: `7px solid ${colorChangeThreshold ? Palette.gray.gray900 : Palette.gray.gray300}`,
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        bottom: '-4px',
        zIndex: 3,
        left: '33%',
        transform: 'translateX(-50%)',
        width: 0,
        height: 0,
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderTop: `5px solid ${colorChangeThreshold ? Palette.yellow.yellow300 : Palette.white}`,
    },
}));

const CommentBubble = ({ count, isSmall = false }) => {
    const colorChangeThreshold = false;
    return (
        <StyledCommentBubble colorChangeThreshold={colorChangeThreshold} isSmall={isSmall}>
            {count}
        </StyledCommentBubble>
    );
};

CommentBubble.propTypes = {
    count: PropTypes.number.isRequired,
    isSmall: PropTypes.bool,
};

export default CommentBubble;
